import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  createCalendar,
  getCalendarsByGroupId,
} from "store/slices/calendarSlice";
import { closeModal } from "store/slices/modalsSlice";
import CalendarForm from "./calendar-form";

const NewCalendar = ({ modalProps }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state?.calendars);
  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const [serverError, setServerError] = useState(null);

  // Vérifier si c'est notre modal qui est ouvert
  const open = isModalOpen && modalType === "new_calendar";

  // Gérer la soumission du formulaire
  const handleFinish = (values) => {
    setServerError(null);
    
    dispatch(createCalendar(values))?.unwrap()?.then(() => {
        // Si la séance est créée pour un groupe spécifique, recharger les séances du groupe
        if (values?.groupId) {
          dispatch(getCalendarsByGroupId(values?.groupId));
        }
        dispatch(closeModal());
      })?.catch((err) => {
        // Gérer les différents formats d'erreur possibles du backend
        let errorMessage = '';
        
        if (typeof err === 'object') {
          // Si c'est un objet d'erreur avec une structure spécifique
          if (err?.message) {
            errorMessage = err?.message;
          } else if (err?.error) {
            errorMessage = err?.error;
          } else if (err?.data?.message) {
            errorMessage = err?.data?.message;
          } else {
            errorMessage = JSON?.stringify(err);
          }
        } else {
          // Si c'est une chaîne simple
          errorMessage = err;
        }
        
        setServerError(errorMessage || t("calendars.form.error.generic", "Une erreur s'est produite lors de la création de la planification."));
      });
  };

  // Gérer l'annulation
  const handleCancel = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      title={
        modalProps?.groupId
          ? t("calendars.new.titleWithGroup", "Nouvelle séance pour le groupe")
          : t("calendars.new.title", "Nouvelle planification")
      }
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      <CalendarForm
        initialValues={modalProps}
        onFinish={handleFinish}
        onCancel={handleCancel}
        loading={loading}
        error={serverError || error}
      />
    </Modal>
  );
};

export default NewCalendar;